export class LoadClubs {
  static readonly type = '[Clubs] Load clubs';

  constructor(readonly seasonId: string, readonly competitionId: string) {}
}
